<div class="x-section__headline">
	<div class="first-row">
		<h2 class="mat-h1 overflowing" data-test-id="headline" aria-labelledby="sr-label-vorg">
			<schir-int-client-aktenzeichen
					[aktenzeichen]="verfahren.aktenzeichen"
					[verfahrenId]="verfahrenId"
			/>
		</h2>
		@if ((verfahren | hasResourceLink: linkRel.ZUGEORDNETE_VERFAHREN) && verfahren.zuordnungen) {
			<button mat-icon-button (click)="buttons.openZugeordneteVerfahrenDialog()"
			        data-test-id="zugeordnete-verfahren-icon-button"
			        aria-label="Zugeordnete Verfahren bearbeiten"
			        matTooltip="Zugeordnete Verfahren bearbeiten">
				@if (verfahren.zuordnungen.hauptverfahren.aktenzeichen === verfahren.stammdaten.aktenzeichen) {
					<mat-icon style="transform: rotate(180deg)">call_split</mat-icon>
				} @else {
					<mat-icon>merge_type</mat-icon>
				}
			</button>
		}
		<schir-int-client-button-with-menu #buttons [verfahren]="verfahren"/>
	</div>
	@if (standortAkte) {
		<div class=".c-row--secondary" data-test-id="standort-akte"><span>Standort Akte</span>: {{ standortAkte }}</div>
	}
</div>
<div class="x-section__subline">
	<i class="material-icons" aria-hidden="true">file_copy</i>
	<h3 class="mat-body margin-right-auto">Vorgänge</h3>
	@if (verfahren | hasResourceLink: verfahrenLinkRel.CREATE_VORGANG) {
		<schir-int-client-create-vorgang-button [verfahren]="verfahren"
		                                        cssClass="focus-inwards-light schir-inline-button"/>
	}
</div>
<div class="x-section__main">
	<div class="c-spinner" data-test-id="spinner" #spinner>
		<mat-spinner/>
	</div>
	@if (vorgaengeInVerfahren | async; as _vorgaengeInVerfahren) {
		<ul class="c-list">
			@for (vorgang of _vorgaengeInVerfahren; track vorgang) {
				<schir-int-client-vorgang-in-verfahren [vorgang]="vorgang"
				                                       [selected]="isSelected(vorgang) | async"
				                                       (selectedChange)="setSelected(vorgang)"
				                                       (notizChange)="updateNotiz(vorgang, $event)"/>
			}
		</ul>
	}
</div>
<span id="sr-label-vorg" class="sr-only">{{ verfahren.aktenzeichen }} Vorgänge</span>
